import { render } from "./categoriesSlider.vue?vue&type=template&id=2738b4dd"
import script from "./categoriesSlider.vue?vue&type=script&lang=js"
export * from "./categoriesSlider.vue?vue&type=script&lang=js"

import "./categoriesSlider.vue?vue&type=style&index=0&id=2738b4dd&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__